// Détection dynamique et sécurisée de l'environnement (Sandbox vs Production vs Local)
const resolveApiUrl = (): string => {
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    if (hostname.includes('sandbox.mct.ci')) {
      return 'https://api.sandbox.mct.ci/api';
    }
    if (hostname.includes('mct.ci')) {
      return 'https://api.mct.ci/api';
    }
  }
  return process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
};

const resolveBaseUrl = (): string => {
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    if (hostname.includes('sandbox.mct.ci')) {
      return 'https://api.sandbox.mct.ci';
    }
    if (hostname.includes('mct.ci')) {
      return 'https://api.mct.ci';
    }
  }
  return process.env.REACT_APP_API_URL?.replace(/\/api$/, '') || 'http://localhost:3000';
};

// API configuration
export const API_URL = resolveApiUrl();
// Base URL for images and static files (without /api)
export const BASE_URL = resolveBaseUrl();

// Other configuration constants can be added here
export const APP_NAME = 'MCT Maintenance Dashboard';
export const TOKEN_KEY = 'mct_maintenance_token';
export const APP_VERSION = '1.0.0';
export const USER_ROLES = {
    ADMIN: 'admin',
    TECHNICIAN: 'technician',
    CUSTOMER: 'customer',
  };

// Add any other configuration values you might need
export const config = {
  api: {
    timeout: 30000, // 30 seconds
    maxRetries: 3,
  },
  // Add more configuration as needed
};

const appConfig = {
  API_URL,
  BASE_URL,
  APP_NAME,
  APP_VERSION,
  ...config,
};

export default appConfig;
